import { render, staticRenderFns } from "./bsp-dicts-radio.vue?vue&type=template&id=e3bdc330&scoped=true&"
import script from "./bsp-dicts-radio.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-radio.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-radio.vue?vue&type=style&index=0&id=e3bdc330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bdc330",
  null
  
)

export default component.exports